
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { resetExplorerToInitialState, setExplorerLoading, setFiles, setFolders, setNewFolder, setSpaceRootFolders } from 'src/state/explorer/explorerSlice';
import { resetLocationsToInitialState, setLocations, setLocationsLoading } from 'src/state/locations/locationSlice';
import { selectCurrentSpace, setCurrentSpace } from 'src/state/profile/profileSlice';
import { resetSearchToInitialState } from 'src/state/search/searchSlice';
import useApi from './useApi';
import { SpaceDto } from '@braoshzmvavz/picnube-common';
import { setAlbums } from 'src/state/albums/albumsSlice';


const useAppState = () => {
    const dispatch = useAppDispatch();
    const space = useAppSelector(selectCurrentSpace);

    const {
        fetchLocations,
        fetchFolders,
        fetchAlbumsBySpaceId,
    } = useApi();

    const changeToSpace = async (space: SpaceDto): Promise<void> => {
        dispatch(setCurrentSpace(space));
        dispatch(resetSearchToInitialState());
        dispatch(resetExplorerToInitialState());
        dispatch(resetLocationsToInitialState());

        dispatch(setFolders([]));
        dispatch(setSpaceRootFolders([]));
        dispatch(setFiles([]));
        dispatch(setNewFolder(null));

        dispatch(setLocationsLoading(true));
        dispatch(setExplorerLoading(true));

        localStorage.setItem("currentSpace", space.id);

        fetchFolders(space.id).then((response) => {
            if (response != null) {
                dispatch(setSpaceRootFolders(response));
                dispatch(setFolders(response));
                dispatch(setExplorerLoading(false));
            }
        });

        fetchLocations(space.id).then((response) => {
            if (response != null) {
                dispatch(setLocations(response));
                dispatch(setLocationsLoading(false));
            }
        });

        fetchAlbumsBySpaceId(space.id).then((response) => {
            if (response != null) {
                dispatch(setAlbums(response));
            }
        });
    }

    return {
        changeToSpace,
    };
};

export default useAppState;
